<template>
  <div class="input-container">
    <label :class="{ labelObrigatorio: campoVazio && required, 'mb-0': hasMarginBottomLabel}">
      {{ label }}</label
    >
    <div class="field">
      <p class="control">
        <input
          class="input"
          type="number"
          :placeholder="placeholder"
          :id="id"
          :min="min"
          :max="max"
          :maxlength="maxLength"
          :required="required"
          :disabled="desabilitarInput"
          :class="{ inValida: campoVazio && required }"
          :value="modelValue"
          @input="(event) => executarValidacoes(event.target.value, true)"
          @blur="(event) => executarValidacoes(event.target.value, true)"
          @keydown="(event) => (bloquearDecimal(event), bloquearOperador(event), this.limitarCaracteres(event))"
        />
      </p>
    </div>

    <div v-if="required && !disableErrorMessage" class="mensagemDeErro">
      <span v-if="campoVazio && label != null" class="campo-obrigatório"
        >{{ label }} é obrigatório.</span
      >
      <span v-else-if="campoVazio" class="campo-obrigatório">Campo obrigatório.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfNumberInput",
  props: {
    label: String,
    hasMarginBottomLabel: {
      type: [Boolean],
      required: false,
      default: false
    },
    placeholder: String,
    required: {
      type: [Boolean],
      required: false,
      default: true
    },
    id: String,
    min: String,
    max: String,
    maxLength: String,
    arredondarValor: {
      type: [Boolean],
      required: false,
      default: true,
    },
    modelValue: String,
    desabilitarDecimal: {
      type: [Boolean],
      required: false,
      default: false,
    },
    desabilitarOperador: {
      type: [Boolean],
      required: false,
      default: true,
    },
    desabilitarInput: {
      type: [Boolean],
      required: false,
      default: false,
    },
    disableErrorMessage: { type: [Boolean], default: false }
  },
  data() {
    return {
      campoVazio: false,
    };
  },
  methods: {
    verificarSeInputEstaVazio(valor) {
      if (valor == null || valor == "") {
        this.campoVazio = true
      } else {
        this.campoVazio = false
      }
      return this.campoVazio;
    },

    normalizarValorInvalido(valor = this.modelValue) {
      const minNumero = parseInt(this.min);
      const maxNumero = parseInt(this.max);
      const valorNumero = parseInt(valor);
      if (!!this.arredondarValor && !!this.min && valorNumero < minNumero) {
        return this.min;
      } else if (
        !!this.arredondarValor &&
        !!this.max &&
        valorNumero > maxNumero
      ) {
        return this.max;
      }
      return valor;
    },

    iniciarInputComValor(valor) {
      this.executarValidacoes(valor, true);
    },

    executarValidacoes(valor = this.modelValue, emitirValor) {
      this.verificarSeInputEstaVazio(valor);
      valor = this.normalizarValorInvalido(valor);
      if (emitirValor) {
        valor = this.removerDecimal(valor);
        valor = this.removerOperador(valor);
        this.emitirNovoValor(valor);
      }
    },

    removerDecimal(valor) {
      if (!this.desabilitarDecimal) return valor;
      return valor.replace(".", "").replace(",", "");
    },
    
    removerOperador(valor) {
      if(!this.desabilitarOperador) return valor;
      return valor.replace("+", "").replace("-", "").replace("e","");
    },

    bloquearDecimal(event) {
      if (this.desabilitarDecimal && (event.key === "." || event.key === ",")) {
        event.preventDefault();
      }
    },

    bloquearOperador(event) {
      if (this.desabilitarOperador && (event.key === "+" || event.key === "-" || event.key === "e")) {
        event.preventDefault();
      }
    },

    limitarCaracteres(event) {
      if(!!!this.maxLength) return;
      const tamanho = parseInt(this.maxLength);
      const valor = event.target.value;
      if(valor.length >= tamanho && (event.key !== "Backspace" && event.key !== "Delete")) {
        event.preventDefault();
      }
    },

    emitirNovoValor(valor = this.modelValue) {
      const valorComoString = "" + valor + "";
      this.resolveConcorrencia(() =>
        this.$emit("update:modelValue", valorComoString)
      );
    },

    limparCampo() {
      this.emitirNovoValor("");
      this.resolveConcorrencia(() =>
        this.limparValidacao(),
        100
      );
    },

    limparValidacao() {
      this.campoVazio = false;
    },

    resolveConcorrencia(arrowFunction = () => {}, wait = 1) {
      setTimeout(arrowFunction, wait);
    },
    
    limparInput() {
      this.modelValue == ''
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
</style>
